module.exports = __webpack_public_path__ + "img/sxjm-logo.e67c84ab.png";